import { Button } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReferralRequestService } from './generated/referral-request';
import { useReferralRequestForm } from './hooks/use-referral-request-form';
import { ReferralRequestForm } from './referral-request-form';
import { toFormValues, type DraftReferralRequestLike } from './referral-request-form-utils';

type ReferralRequestViewProps = {
  readonly id: string;
  readonly service: ReferralRequestService;
  readonly referralRequest: DraftReferralRequestLike;
};

const ReferralRequestView = ({ id, service, referralRequest }: ReferralRequestViewProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const form = useReferralRequestForm(toFormValues(referralRequest, service.respondentTypes), service.respondentTypes);
  const nextTarget = service.referrerSurvey ? `/referral-request/${id}/survey/view` : '/';
  const nextKey = service.referrerSurvey ? 'common.buttons.next' : 'common.buttons.back';

  return (
    <ReferralRequestForm
      disabled
      form={form}
      renderActions={() => (
        <Button onClick={() => navigate(nextTarget)} type="button">
          {t(nextKey)}
        </Button>
      )}
      service={service}
    />
  );
};

export { ReferralRequestView };
